<template>
    <div class="headline" style="marginTop:15px;">
        <div class="sub-title">
            企业认证标识
        </div>
        <div class="checkbox-line">
            <v-checkbox v-model="iconValue" label="展示企业认证标识" @change="changeEvent"></v-checkbox>
            <div class="checkbox-desc">
                <v-icon
                    v-tip:compIcon.hover.delay
                    name="input_question"
                    class="question-mark"
                    style="width:16px;height:16px;"
                ></v-icon>
            </div>
            <v-tip ref="compIcon" placement="top" :gap="10" kind="small" clazz="question-hint">
                <span>开启后，含有对外资料卡的新开页会话窗口中将在头像上展示企业认证标识</span>
            </v-tip>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        iconValue: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        changeEvent() {
            this.$emit('change', this.iconValue);
        }
    }
};
</script>
<style lang="less">
@import '~@/common/common';
.headline {
    color: #1e2330;
    .sub-title {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        margin-bottom: 8px;
    }
    .checkbox-desc {
        display: inline-flex;
        overflow: hidden;
        margin-left: 20px;
        max-width: 504px;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: @mainLightGray;
        cursor: default;
    }
    .checkbox-line {
        display: flex;
        align-items: center;
        margin-top: 14px;
        height: 20px;
        line-height: 20px;

        .v-checkbox {
            float: left;
        }
    }
    .desc-content {
        display: inline-block;
        margin-left: 10px;
        font-size: 14px;
        font-weight: 400;
        color: @mainLightGray;

        .change-basic {
            color: #4a70ff;
        }
    }
}
</style>
